import { CSSProperties } from "react";

export const css = (properties: CSSProperties) => properties;